import firebase from '@/firebase';

export default {
  register(email, password) {
    return firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(response => response.user);
  },

  createUserDocument(uid, user) {
    return firebase
      .firestore()
      .collection('users')
      .doc(uid)
      .set(user);
  },

  updateUserDocument(uid, user){
    return firebase
      .firestore()
      .collection('users')
      .doc(uid)
      .update(user);
  },

  getUser() {
    return firebase
      .firestore()
      .collection('users')
      .doc(firebase.auth().currentUser.uid)
      .get()
      .then(doc => doc.data());
  },

  deleteUser() {
    return firebase
      .auth()
      .currentUser
      .delete();
  },

  logIn(email, password) {
    return firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(response => response.user);
  },

  logOut() {
    return firebase.auth().signOut();
  },

  sendPasswordResetEmail(email) {
    return firebase.auth().sendPasswordResetEmail(email, {
      url: `${window.location.origin}/login`,
    });
  },

  sendEmailVerification() {
    return firebase.auth().currentUser.sendEmailVerification({
      url: `${window.location.origin}/checkout`,
    });
  },
};
